import Vue from 'vue'
import App from './App.vue'
import router from './router'
import * as api from './utils/api'
import {
	Icon
} from 'vant';
import {
	Lazyload,
	Image as VanImage,
	Switch,
	ImagePreview,
	Toast
} from 'vant';
import store from './store'
import 'vant/lib/index.less';
import $ from "jquery";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.prototype.api = api;

Vue.prototype.$JQ = $;
Vue.prototype.imagePreview = ImagePreview;
Vue.prototype.Toast = Toast;
Vue.prototype.defUrl = 'https://panel.vmr.cn'

Vue.use(Icon);
Vue.use(ElementUI);
Vue.use(Lazyload);
Vue.use(VanImage);
Vue.use(Switch);
Vue.config.productionTip = false

// 导航拦截
router.beforeEach((to,from,next) => {
  if(to.meta.login && !localStorage.getItem('token')){
    next({path:'/login'})
  }else{
    next()
  }
})

new Vue({
	router,
	store,
	render: h => h(App)
}).$mount('#app')
